import "../scss/app.scss";

import { initTheme } from "@js/core/theme";
import { initLanguageDropdown } from "@js/core/language-dropdown";
import { initRevealOnScroll } from "@js/core/reveal-on-scroll";
import { initHeaderShell } from "@js/core/header-shell";

import { initSiteBootstrap } from "@js/components/common/site-bootstrap";
import { initVirtualPosLogin } from "@js/components/virtual-pos/login";
import { initVirtualPosCheckout } from "@js/components/virtual-pos/checkout";
import { initBankAccountsPage } from "@js/components/pages/bank-accounts";
import { initTdsDetailPage, initTdsPage } from "@js/components/pages/tds";
//import { initEventsPage } from "@js/components/pages/events-v2";
import { initEventsPage } from "@js/components/pages/events";
import { initContactPage } from "@js/components/pages/contact";
import { initAnalytics } from "@js/components/common/analytics";


async function initCommon() {
    initHeaderShell?.();
    initRevealOnScroll?.();
    initLanguageDropdown?.();
    initTheme?.();
    initAnalytics();

    await initSiteBootstrap();
}

async function initPage() {
    const page = document.body?.dataset?.page || "";

    switch (page) {
        case "virtual-pos-login":
            await initVirtualPosLogin();
            break;

        case "virtual-pos-checkout":
            await initVirtualPosCheckout();
            break;

        case "bank-accounts":
            await initBankAccountsPage();
            break;

        case "tds":
            await initTdsPage();
            break;

        case "tds-detail":
            initTdsDetailPage();
            break;

        case "events":
            await initEventsPage();
            break;

        case "contact":
            await initContactPage();
            break;

        default:
            break;
    }
}

document.addEventListener("DOMContentLoaded", async () => {
    await initCommon();
    await initPage();
});
